export default {
  title: 'Brands',
  form: {
    name: {
      placeholder: 'Search brand...',
    },
  },
  fields: {
    id: '#',
    name: 'Name',
    address: 'Address',
    subdomain: 'Subdomain',
    shop_url: 'Shop URL',
    companies: 'Companies',
    slug: 'Slug',
    actions: '',
  },
  empty_list: 'No brands yet',
  modals: {
    delete_franchise: {
      title: 'Are you sure you want to delete the brand {{name}}?',
    },
  },
  buttons: {
    new_franchise: '+ Add brand',
    export_restaurants: 'Export Restaurants',
    edit: 'Edit',
    delete: 'Delete',
    view_dashboard_as_owner: 'View dashboard as owner',
    open_shop: 'Open shop',
  },
  toasts: {
    failed_to_load_data: 'Failed to load data',
    failed_to_delete_franchise: 'Failed to delete brand',
    franchise_got_deleted: 'Brand got deleted',
    failed_to_create_magic_link: 'Failed to create magic link',
    no_owner_to_log_in_as: 'No restaurant owner to log in as',
  },
};
